const list = [
    {
      id: 1,
      title: "射鵰英雄傳",
      author: "金庸",
      price: 89,
      img:  "https://books.google.com.hk/books/publisher/content?id=Cde2AAAAQBAJ&hl=zh-TW&pg=PA1529&img=1&zoom=3&sig=ACfU3U12MfvSwLSd_OkbPsTBF4L2yugkZg&w=1280",
      amount: 1,
    },
    {
      id: 2,
      title: "倚天屠龍記",
      author: "金庸",
      price: 98,
      img: "https://books.google.com.hk/books/publisher/content?id=a3uMDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U33YL4iQbd8IWkdCLuvlZqteg-n0g&w=1280",
      amount: 1,
    },
    {
      id: 3,
      title: "天龍八部",
      author: "金庸",
      price: 143,
      img: "https://books.google.com.hk/books/publisher/content?id=naKXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U0HrmHt6TAcETdtQeUaaGBE1owa-A&w=1280",
      amount: 1,
    },
    {
      id: 4,
      title: "神鵰俠侶",
      author: "金庸",
      price: 57,
      img: "https://books.google.com.hk/books/publisher/content?id=FdW2AAAAQBAJ&hl=zh-TW&pg=PA1307&img=1&zoom=3&sig=ACfU3U3ihjVMkBNTRkuoLM0AVJcfR0YMVg&w=1280",
      amount: 1,
    },
    {
      id: 5,
      title: "笑傲江湖",
      author: "金庸",
      price: 149,
      img: "https://books.google.com.hk/books/publisher/content?id=wcS7AAAAQBAJ&hl=zh-TW&pg=PA275&img=1&zoom=3&sig=ACfU3U38KrTDKheaL8WFAUoDdpJH97JB8g&w=1280",
      amount: 1,
    },
    {
      id: 6,
      title: "鹿鼎記",
      author: "金庸",
      price: 135,
      img: "https://books.google.com.hk/books/publisher/content?id=qaKXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U3AWMl_qux9erCGSOoHyeZHQCXw9Q&w=1280",
      amount: 1,
    },
    {
      id: 7,
      title: "雪山飛狐 ",
      author: "金庸",
      price: 693,
      img: "https://books.google.com.hk/books/publisher/content?id=maKXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U1zvFMSVgbI2SHrg5PuJgW6HcqoGw&w=1280",
      amount: 1,
    },
    {
      id: 8,
      title: "飛狐外傳",
      author: "金庸",
      price: 289,
      img: "https://books.google.com.hk/books/publisher/content?id=m6KXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U24sLs5Npg1HpthyfZ9kGdEYrNeyA&w=1280",
      amount: 1,
    },
    {
      id: 9,
      title: "俠客行",
      author: "金庸",
      price: 80,
      img: "https://books.google.com.hk/books/publisher/content?id=jaKXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U2hjTxSnvYIoj1UbgVUti_CCa_k2Q&w=1280",
      amount: 1,
    },
    {
      id: 10,
      title: "俠客行",
      author: "金庸",
      price: 86,
      img: "https://books.google.com.hk/books/publisher/content?id=n6KXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U2IwWW7zNitjcRYNz3xFjhri20JEQ&w=1280",
      amount: 1,
    },
    {
      id: 11,
      title: "連城訣",
      author: "金庸",
      price: 120,
      img: "https://books.google.com.hk/books/publisher/content?id=oRG3AAAAQBAJ&hl=zh-TW&pg=PA261&img=1&zoom=3&sig=ACfU3U2ZQyF5fGcGCfoQlltJgpWG6NW23g&w=1280",
      amount: 1,
    },
    {
      id: 12,
      title: "碧血劍",
      author: "金庸",
      price: 157,
      img: "https://books.google.com.hk/books/publisher/content?id=j6KXDwAAQBAJ&hl=zh-TW&pg=PP1&img=1&zoom=3&sig=ACfU3U2bW5abJHyMiPyDFMg10FT4Pbpq-Q&w=1280",
      amount: 1,
    },
];

export default list;